import { Box, Typography } from "@mui/material";
import { palette, spacing } from "../../styles/theme";

export default function SpecsEmptyStatePage() {
  return (
    <Box
      sx={{
        minHeight: 320,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `1px dashed ${palette.grey.lightGrey}`,
        borderRadius: "12px",
        bgcolor: palette.grey.lightBackground,
        px: spacing.groupingDesktop,
        textAlign: "center",
      }}
    >
      <Typography variant="h2">
        Sélectionner un produit pour commencer
      </Typography>
    </Box>
  );
}
